import { render, staticRenderFns } from "./AbroadInvest.vue?vue&type=template&id=c19c789a"
import script from "./AbroadInvest.vue?vue&type=script&lang=js"
export * from "./AbroadInvest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports